import { Button, Col, Form, Row } from "antd";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { CloseOutlined } from "@ant-design/icons";
import usePost from "../../../global/hooks/usePost";
import { useEffect, useRef } from "react";
import { openErrorNotification } from "../../../global/utils/toast";
import { booleanOptions } from "../../../utils/Common";
import { FaTheRedYeti } from "react-icons/fa6";

export const FavoriteForm = ({
  setIsModalOpen,
  selectedData,
  onSuccess,
  isModalOpen,
}) => {
  const [form] = Form.useForm();
  const autoLogin = Form.useWatch("AutoLogin", form);
  const showCredentials = Number(autoLogin) === 1;
  const favoriteUrl = `${process.env.REACT_APP_API_URL}/api/favorites/`;
  const processedResponseRef = useRef(null);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    postData: postAction,
  } = usePost(favoriteUrl);

  useEffect(() => {
    if (isModalOpen) {
      form.resetFields();
      form.setFieldsValue({
        Favorite: 1,
        AutoLogin: 0,
      });
      processedResponseRef.current = null;
    }
  }, [isModalOpen, form]);

  const onFinish = (values) => {
    const isAutoLogin = Number(values.AutoLogin) === 1;
    const modifiedValues = {
      Favorite: Number(values.Favorite),
      AutoLogin: Number(values.AutoLogin),
      ...(isAutoLogin
        ? {
            UserId: values.FavUserId,
            Password: values.FavUserPass,
          }
        : {}),
      SiteNos: selectedData?.map((item) => item.DeviceNo),
    };
    processedResponseRef.current = null;
    postAction(modifiedValues);
  };
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong",
      );
      processedResponseRef.current = null;
    } else if (!postLoading && !postError && postData) {
      const responseKey = JSON.stringify(postData);
      if (processedResponseRef.current === responseKey) {
        return;
      }
      processedResponseRef.current = responseKey;
      setIsModalOpen(false);
      if (onSuccess) {
        onSuccess(postData);
      }
    }
  }, [postError, postData, postLoading, setIsModalOpen, onSuccess]);

  return (
    <Form
      validateTrigger={"onChange"}
      form={form}
      onFinish={onFinish}
      scrollToFirstError
      layout={"vertical"}
      autoComplete={"off"}
    >
      <div>
        <div className="bg-white rounded-[4px] overflow-hidden">
          <div className="px-2 pt-1 pb-3">
            <Row gutter={[16, 8]}>
              <Col span={24}>
                <CustomSelect
                  label="Favorite"
                  name="Favorite"
                  options={booleanOptions}
                  placeholder="Please select"
                  allowClear={false}
                  required
                />
              </Col>
              <Col span={24}>
                <CustomSelect
                  label="Auto Login"
                  name="AutoLogin"
                  options={booleanOptions}
                  placeholder="Please select"
                  allowClear={false}
                  required
                  onChange={(value) => {
                    if (Number(value) !== 1) {
                      form.setFieldsValue({
                        FavUserId: undefined,
                        FavUserPass: undefined,
                      });
                    }
                  }}
                />
              </Col>
              {showCredentials && (
                <>
                  <Col span={24}>
                    <CustomInput
                      label="Username"
                      name="FavUserId"
                      autoComplete="off"
                      required
                    />
                  </Col>
                  <Col span={24}>
                    <CustomInput
                      label="Password"
                      name="FavUserPass"
                      autoComplete="new-password"
                      type="password"
                      noValidation
                      required
                    />
                  </Col>
                </>
              )}
            </Row>
          </div>
          <div className="flex justify-center space-x-2 mt-2.5">
            <Button
              type="primary"
              className="mr-2 min-w-[104px] h-[30px] py-1 px-[10px] font-medium flex items-center "
              onClick={() => form.submit()}
              loading={postLoading}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              <span className="">Apply</span>
            </Button>
            <Button
              className="reset-button"
              onClick={() => {
                form.resetFields();
                setIsModalOpen(false);
              }}
            >
              <CloseOutlined />
              <span>Cancel</span>
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};
